import { render } from "./Organisation.Businesses.Create.vue?vue&type=template&id=675a1880"
import script from "./Organisation.Businesses.Create.vue?vue&type=script&lang=js"
export * from "./Organisation.Businesses.Create.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__